<script setup lang="ts" generic="T extends (String | Number | Object | Date)">
import {IonItem, IonList, IonRadio, IonRadioGroup, RadioGroupCustomEvent} from '@ionic/vue'
import {onMounted, PropType} from 'vue'

const props = defineProps({
    label: String,
    modelValue: {
        type: [String, Number, Object, Date, undefined] as PropType<T>,
    },
    items: {
        type: Array as PropType<T[]>,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false,
        required: false,
    },
    disabledItems: {
        type: Array as PropType<T[]>,
        required: false
    },
    allowUndefined: {
        type: Boolean,
        default: false,
    }
})
const emit = defineEmits({'update:modelValue':(item:T) => true})

onMounted(() => {
    if (!props.modelValue && !props.allowUndefined) {
        emit('update:modelValue', props.items[0])
    }
})

const onChange = (e:RadioGroupCustomEvent) => {
    emit('update:modelValue', e.detail.value)
}
</script>

<template>
<div
    class="radio-group"
>
    <div
        class="label"
    >
        {{ props.label }}
    </div>

    <ion-list>
        <ion-radio-group
            @ionChange="onChange"
            :value="props.modelValue"
        >
            <ion-item
                v-for="(item, index) in props.items"
                :lines="index === (props.items.length - 1) ? 'none' : 'full'"
            >
                <ion-radio
                    label-placement="end"
                    justify="start"
                    :value="item"
                    :disabled="disabled || (disabledItems && disabledItems.includes(item))"
                >
                    <slot
                        :item="item"
                    >
                        {{ item }}
                    </slot>
                </ion-radio>
            </ion-item>
        </ion-radio-group>
    </ion-list>
</div>
</template>

<style lang="scss">
.radio-group {
    > ion-list {
        background-color: var(--ion-color-light);
        border-radius: 1rem;

        ion-radio {
            padding-left: 1em;
        }
    }

    > .label {
        font-size: var(--custom-font-size-small);
        color: var(--ion-color-grey);
        margin-bottom: 0.5em;
    }

    margin-bottom: 1rem;
}
</style>
